module.exports = __webpack_public_path__ + "img/Professional-4.e9d0fe9b.gif";